import * as React from 'react';
import ApplicationList, { Props } from './application_list';
import { shallow, ShallowWrapper } from 'enzyme';
import { ApplicationsState } from '../employer_applications/applications_state';
import applicationDummy from '__fixtures__/application_dummy';

const dummyAppsState = new ApplicationsState({});

const createTestProps = moreProps => {
  return {
    applications: [applicationDummy],
    splatApplications: [applicationDummy, applicationDummy],
    bulkMoveToStep: jest.fn(),
    disengaged: false,
    bulkReject: jest.fn(),
    className: '',
    chatUrl: '',
    contactsUrl: '',
    hiringSteps: [
      {
        description: '',
        hasApplications: true,
        id: 1,
        jobId: 1,
        kind: '',
        message: {
          id: 2,
          text: '',
        },
        name: '',
        order: 1,
        slug: '',
      },
    ],
    moveToStep: jest.fn(),
    rejectApplication: jest.fn(),
    selectedJobId: '',
    setApplication: jest.fn(),
    topFilter: '',
    waitingForScreeningCounter: 20,
    urls: {
      bulkMoveToReviewing: '',
      bulkMoveToStep: '',
      bulkMoveToProposal: '',
      bulkReject: '',
      rateApplication: '',
    },
    loadMoreApplications: jest.fn(),
    appsState: dummyAppsState,
    shouldGroupApplications: jest.fn(),
    ...moreProps,
  };
};

let props: Props;
let wrapped: ShallowWrapper;

describe('Application List component', () => {
  beforeEach(() => {
    props = createTestProps({});
    wrapped = shallow(<ApplicationList {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

describe('when topFilter is waiting', () => {
  beforeEach(() => {
    props = createTestProps({ topFilter: 'waiting' });
    wrapped = shallow(<ApplicationList {...props} />);
  });

  it('renders the waiting for screening message', () => {
    expect(wrapped.find('AlertBox').exists()).toBe(true);
  });

  it('displays the correct message text', () => {
    expect(wrapped.find('AlertBox').dive().text()).toContain("We're reviewing these candidates");
    expect(wrapped.find('AlertBox').dive().text()).toContain('24-48 hours');
  });

  it('does not render the application grid', () => {
    expect(wrapped.find('.grid').exists()).toBe(false);
  });
});

describe('when topFilter is waiting with 0 candidates', () => {
  beforeEach(() => {
    props = createTestProps({ topFilter: 'waiting', waitingForScreeningCounter: 0 });
    wrapped = shallow(<ApplicationList {...props} />);
  });

  it('displays the no candidates message', () => {
    expect(wrapped.find('AlertBox').dive().text()).toContain('No candidates waiting for review');
  });
});

test.todo('add more tests');
